import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-16-缩放",
  "use": "icon-16-缩放-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-16-缩放\">\n<style type=\"text/css\">\n\t#icon-16-缩放 .st0{fill:none;stroke:#556655;stroke-width:2;stroke-miterlimit:10;}\n</style>\n<polyline class=\"st0\" points=\"5,0 5,5 0,5 \" />\n<polyline class=\"st0\" points=\"11,0 11,5 16,5 \" />\n<polyline class=\"st0\" points=\"5,16 5,11 0,11 \" />\n<polyline class=\"st0\" points=\"11,16 11,11 16,11 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol